import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function InvoicesTicketsEditorProvider({ children }) {
  useInjectSaga({ key: 'invoicesTicketsEditorProvider', saga });
  useInjectReducer({ key: 'invoicesTicketsEditorProvider', reducer });

  return React.Children.only(children);
}

InvoicesTicketsEditorProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withInvoiceTicketsEditor } from './withInvoiceTicketsEditor';
export default compose(withConnect, memo)(InvoicesTicketsEditorProvider);
